import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * タイムアウト画面
 * @returns
 */
const Timeout = () => {
  return (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
        paddingTop: "35vh",
      }}
    >
      <Typography>
        <strong>
          処理がタイムアウトしました。
          <br />
          通信環境が良い場所で、再操作をお願いします。
        </strong>
      </Typography>
    </Box>
  );
};
export default Timeout;
